module.exports = __webpack_public_path__ + "img/veeam-logo.ea0d8cbf.png";